export const HEADER = {
    MOBILE_HEIGHT: 50,
    MAIN_DESKTOP_HEIGHT: 70,
};
